import React, { useEffect, useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import Cookies from "js-cookie";
import { ProductIds, Roles } from "../constants";

function AuthGuard({ children, isPublic = false, role }) {
  const location = useLocation();
  const token = useSelector((state) => state.auth.token);
  const userRole = useSelector((state) => state.auth.role);
  console.log("🚀 ~ AuthGuard ~ userRole:", userRole);
  const navigate = useNavigate();

  const isValid = useMemo(() => {
    if (token !== null && !isPublic) {
      return true;
    } else if (isPublic && token === null) {
      return true;
    } else {
      return false;
    }
  }, [token, isPublic]);

  useEffect(() => {
    if (!token && location.pathname.includes("checkout")) {
      const currentUrl = location.pathname;
      console.log("Storing intended URL:", currentUrl);
      // Save the intended URL in Cookies
      Cookies.set(
        "intendedUrl",
        `${process.env.REACT_APP_WORD_PRESS_REDIRECT_URI}/pricing/`
      );
    }

    if (isValid) {
      if (role !== "all" && role !== userRole) {
        if (userRole === Roles.PATIENT) {
          navigate("/patient_dashboard");
        } else if (userRole === Roles.DENTIST) {
          navigate("/dentist_portal");
        } else if (userRole === Roles.GUEST) {
          navigate(`/checkout?products=${ProductIds.COMPLETE_SOLUTION_CUSTOM}`);
        }
      }
    } else {
      if (token) {
        if (role !== "all" && role !== userRole) {
          if (userRole === Roles.PATIENT) {
            navigate("/patient_dashboard");
          } else if (userRole === Roles.DENTIST) {
            navigate("/dentist_portal");
          } else if (userRole === Roles.GUEST) {
            navigate(
              `/checkout?products=${ProductIds.COMPLETE_SOLUTION_CUSTOM}`
            );
          }
        }
      } else {
        navigate("/");
      }
      console.log("You are in wrong way");
    }
  }, [isValid, role, userRole, token, navigate, location.pathname]);

  return <>{isValid && children}</>;
}

export default AuthGuard;
